// Dashboard do dia (aba Geral): o que está acontecendo agora no suporte, com cor pela meta de prazo.
// Atualiza sozinho a cada 30 s; cada número leva à tela onde se age sobre ele.
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Paper, Typography, makeStyles } from "@material-ui/core";

import suporteApi from "../api";

export const hm = (m) => (m === null || m === undefined ? "—" : m >= 1440 ? `${Math.floor(m / 1440)}d ${Math.floor((m % 1440) / 60)}h`
  : m >= 60 ? `${Math.floor(m / 60)}h${String(m % 60).padStart(2, "0")}` : `${m} min`);

export const useEstilosGestao = makeStyles((theme) => ({
  raiz: { flex: 1, overflowY: "auto", padding: theme.spacing(2), display: "flex", flexDirection: "column", gap: 14, ...theme.scrollbarStyles },
  kpis: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))", gap: 12 },
  kpi: { padding: "12px 14px", borderTop: `4px solid ${theme.palette.divider}`, display: "flex", flexDirection: "column", gap: 2 },
  clicavel: { cursor: "pointer", "&:hover": { boxShadow: theme.shadows[3] } },
  ok: { borderTopColor: theme.palette.success.main },
  warn: { borderTopColor: theme.palette.warning.main },
  crit: { borderTopColor: theme.palette.error.main },
  info: { borderTopColor: theme.palette.primary.main },
  roxo: { borderTopColor: "#7b1fa2" },
  rot: { fontSize: 12.5, color: theme.palette.text.secondary },
  val: { fontSize: 28, fontWeight: 700, lineHeight: 1.15, fontVariantNumeric: "tabular-nums" },
  det: { fontSize: 12, color: theme.palette.text.secondary },
  grade: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))", gap: 14 },
  painel: { padding: 14, minWidth: 0 },
  titulo: { fontSize: 14, fontWeight: 600, marginBottom: 10, display: "flex", gap: 8, alignItems: "baseline", flexWrap: "wrap" },
  sub: { fontWeight: 400, fontSize: 12, color: theme.palette.text.secondary },
  linha: { display: "flex", alignItems: "center", gap: 10, padding: "4px 0", fontSize: 13 },
  nome: { flex: "0 0 40%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  trilho: { flex: 1, height: 10, borderRadius: 99, background: theme.palette.action.hover, overflow: "hidden" },
  barra: { height: "100%", borderRadius: 99, background: theme.palette.primary.main },
  num: { minWidth: 56, textAlign: "right", fontVariantNumeric: "tabular-nums", fontWeight: 600 },
  tabela: { overflowX: "auto", "& table": { width: "100%", borderCollapse: "collapse", fontSize: 13 },
    "& th": { textAlign: "left", fontWeight: 600, color: theme.palette.text.secondary, fontSize: 12, padding: "6px 8px",
      borderBottom: `1px solid ${theme.palette.divider}`, whiteSpace: "nowrap" },
    "& td": { padding: "7px 8px", borderBottom: `1px solid ${theme.palette.divider}`, whiteSpace: "nowrap" },
    "& .n": { textAlign: "right", fontVariantNumeric: "tabular-nums" }, "& tbody tr:hover td": { background: theme.palette.action.hover } },
  pill: { fontSize: 11.5, fontWeight: 600, padding: "2px 8px", borderRadius: 99, whiteSpace: "nowrap" },
  pOk: { background: "rgba(46,125,50,.14)", color: theme.palette.success.main },
  pWarn: { background: "rgba(237,108,2,.14)", color: theme.palette.warning.main },
  pCrit: { background: "rgba(211,47,47,.14)", color: theme.palette.error.main },
  vazio: { color: theme.palette.text.secondary, fontSize: 13 },
  nota: { fontSize: 12, color: theme.palette.text.secondary },
}));

export const Kpi = ({ rot, val, det, tom = "info", onClick }) => {
  const c = useEstilosGestao();
  return (
    <Paper variant="outlined" className={`${c.kpi} ${c[tom]} ${onClick ? c.clicavel : ""}`} onClick={onClick}>
      <span className={c.rot}>{rot}</span>
      <span className={c.val}>{val ?? "—"}</span>
      {det && <span className={c.det}>{det}</span>}
    </Paper>
  );
};

export const Barras = ({ linhas, max, fmt = (v) => v, cor, onClick }) => {
  const c = useEstilosGestao();
  const m = max || Math.max(1, ...linhas.map((l) => l.total || 0));
  if (!linhas.length) return <div className={c.vazio}>Nada no período.</div>;
  return linhas.map((l) => (
    <div key={l.nome} className={c.linha} style={onClick ? { cursor: "pointer" } : undefined} onClick={onClick ? () => onClick(l) : undefined}>
      <span className={c.nome} title={l.nome}>{l.nome}</span>
      <span className={c.trilho}><span className={c.barra} style={{ display: "block", width: `${Math.max(2, (100 * (l.total || 0)) / m)}%`, background: cor ? cor(l) : undefined }} /></span>
      <span className={c.num}>{fmt(l.total, l)}</span>
    </div>
  ));
};

export const Pill = ({ tom, children }) => {
  const c = useEstilosGestao();
  return <span className={`${c.pill} ${tom === "ok" ? c.pOk : tom === "warn" ? c.pWarn : c.pCrit}`}>{children}</span>;
};

export const pillPrazo = (p) => (p === null || p === undefined ? "—" : <Pill tom={p >= 90 ? "ok" : p >= 75 ? "warn" : "crit"}>{`${p}%`}</Pill>);

const Hoje = () => {
  const c = useEstilosGestao();
  const history = useHistory();
  const [d, setD] = useState(null);
  const carregar = useCallback(() => {
    suporteApi.get("/api/gestao/hoje").then((r) => setD(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    carregar();
    const t = setInterval(() => !document.hidden && carregar(), 30000);
    return () => clearInterval(t);
  }, [carregar]);
  if (!d) return <div className={c.raiz}><Typography color="textSecondary">Carregando…</Typography></div>;

  const resp = d.primeira_resposta;
  const respTom = resp.media === null ? "info" : resp.meta && resp.media > resp.meta ? "crit" : resp.meta && resp.media > resp.meta * 0.75 ? "warn" : "ok";
  const delta = d.finalizados.ontem ? Math.round((100 * (d.finalizados.hoje - d.finalizados.ontem)) / d.finalizados.ontem) : null;
  const corFaixa = (l) => (l.nome.startsWith("Até") ? "#2e7d32" : l.nome.startsWith("1 a") ? "#85C440" : l.nome.startsWith("4") ? "#ed6c02" : "#d32f2f");

  return (
    <div className={c.raiz}>
      <div className={c.kpis}>
        <Kpi rot="Chamados abertos agora" val={d.abertos.total} det={`${d.abertos.tecnicos} técnicos · ${d.abertos.internos} internos`}
          onClick={() => history.push("/suporte/quadro")} />
        <Kpi rot="Aguardando atendimento" val={d.aguardando.total} tom={d.aguardando.total ? "warn" : "ok"}
          det={d.aguardando.total ? `mais antigo há ${hm(d.aguardando.mais_antigo_min)}` : "ninguém esperando"} onClick={() => history.push("/tickets")} />
        <Kpi rot="1ª resposta (média hoje)" val={hm(resp.media)} tom={respTom} det={resp.meta ? `meta: até ${resp.meta} min` : ""} />
        <Kpi rot="Fora do prazo" val={d.fora_do_prazo.total} tom={d.fora_do_prazo.total ? "crit" : d.fora_do_prazo.perto ? "warn" : "ok"}
          det={d.fora_do_prazo.perto ? `${d.fora_do_prazo.perto} perto do prazo` : "dentro das metas"} onClick={() => history.push("/suporte/quadro")} />
        <Kpi rot="Formulários para validar" val={d.para_validar.total} tom="roxo"
          det={d.para_validar.mais_de_1h ? `${d.para_validar.mais_de_1h} há mais de 1 h` : "em dia"} onClick={() => history.push("/suporte/validar")} />
        <Kpi rot="Finalizados hoje" val={d.finalizados.hoje} tom="ok"
          det={delta === null ? `ontem: ${d.finalizados.ontem}` : `${delta >= 0 ? "▲" : "▼"} ${Math.abs(delta)}% vs ontem (${d.finalizados.ontem})`} />
      </div>

      <div className={c.grade}>
        <Paper variant="outlined" className={c.painel}>
          <div className={c.titulo}>Fila de espera <span className={c.sub}>conversas sem atendente no WhatsApp</span></div>
          {d.aguardando.lista.length ? (
            <div className={c.tabela}><table><thead><tr><th>Contato</th><th>Fila</th><th className="n">Esperando</th></tr></thead>
              <tbody>{d.aguardando.lista.map((t) => (
                <tr key={t.ticket} style={{ cursor: "pointer" }} onClick={() => history.push(`/tickets/${t.ticket}`)}>
                  <td>{t.contato}</td><td>{t.fila}</td>
                  <td className="n"><Pill tom={t.minutos > 30 ? "crit" : t.minutos > 10 ? "warn" : "ok"}>{hm(t.minutos)}</Pill></td>
                </tr>))}</tbody></table></div>
          ) : <div className={c.vazio}>Nenhuma conversa aguardando.</div>}
        </Paper>
        <Paper variant="outlined" className={c.painel}>
          <div className={c.titulo}>Chamados abertos por tempo <span className={c.sub}>desde a abertura do card</span></div>
          <Barras linhas={d.envelhecimento.map((e) => ({ nome: e.faixa, total: e.total }))} cor={corFaixa} onClick={() => history.push("/suporte/quadro")} />
        </Paper>
      </div>

      {d.fora_do_prazo.lista.length > 0 && (
        <Paper variant="outlined" className={c.painel}>
          <div className={c.titulo}>Fora do prazo ou perto dele</div>
          <div className={c.tabela}><table><thead><tr><th>O.S</th><th>Local</th><th>Tipo</th><th>Atendente</th><th className="n">Aberto há</th><th className="n">Meta</th></tr></thead>
            <tbody>{d.fora_do_prazo.lista.map((a) => (
              <tr key={a.id} style={{ cursor: "pointer" }} onClick={() => history.push("/suporte/quadro")}>
                <td>{a.os || "—"}</td><td>{a.local || "—"}</td><td>{a.tipo}</td><td>{a.atendente}</td>
                <td className="n"><Pill tom={a.minutos > a.meta ? "crit" : "warn"}>{hm(a.minutos)}</Pill></td><td className="n">{hm(a.meta)}</td>
              </tr>))}</tbody></table></div>
        </Paper>
      )}

      <div className={c.grade}>
        <Paper variant="outlined" className={c.painel}>
          <div className={c.titulo}>Equipe hoje</div>
          {d.equipe.length ? (
            <div className={c.tabela}><table><thead><tr><th>Atendente</th><th className="n">Abertos</th><th className="n">Finalizados hoje</th>
              <th className="n">Tempo médio</th><th className="n">1ª resposta</th></tr></thead>
              <tbody>{d.equipe.map((e) => (
                <tr key={e.atendente}><td>{e.atendente}</td><td className="n">{e.abertos}</td><td className="n">{e.finalizados}</td>
                  <td className="n">{hm(e.tempo)}</td>
                  <td className="n">{e.resp === null ? "—" : <Pill tom={resp.meta && e.resp > resp.meta ? "crit" : "ok"}>{hm(e.resp)}</Pill>}</td></tr>))}
              </tbody></table></div>
          ) : <div className={c.vazio}>Sem movimento hoje.</div>}
        </Paper>
        <Paper variant="outlined" className={c.painel}>
          <div className={c.titulo}>Abertos agora por cliente</div>
          <Barras linhas={d.por_cliente} />
          <div className={c.titulo} style={{ marginTop: 14 }}>Por sistema</div>
          <Barras linhas={d.por_sistema} />
        </Paper>
      </div>
      <div className={c.nota}>Atualiza sozinho a cada 30 segundos. Cores pela meta de prazo (Gestão → Metas de prazo e causas).</div>
    </div>
  );
};

export default Hoje;
